class JsonApiEndpoint {
  constructor(build) {
    this.entity = build.entity;
    this.bundle = build.bundle;
    this.includes = build.includes;
    this.fields = build.fields;
    this.sort = build.sort;
    this.pageLimit = build.pageLimit;
    this.language = build.language !== 'undefined' ? build.language : false;
    this.alias = build.alias !== undefined ? build.alias : false;
  }

  toString() {
    const buildFields = fields => {
      let fieldQueryStr = '';
      Object.keys(fields).forEach(resourceId => {
        const fixedId = resourceId.replace(/_/g, '-');
        fieldQueryStr += `&fields[${fixedId}]=${fields[resourceId]}`;
      });
      return fieldQueryStr;
    };

    const includes = this.includes.join();
    const fields = buildFields(this.fields);
    const sort = this.sort.length ? `&sort=${this.sort.join()}` : '';
    const pageLimit = this.pageLimit ? `&page[limit]=${this.pageLimit}` : '';
    // eslint-disable-next-line
    const languageFilter = this.language ? `&filter[langcode][operator]=IN&filter[langcode][value][]=und&filter[langcode][value][]=${this.language}` : '';
    const alias = this.alias ? '&includeAlias=true' : '';

    return `/jsonapi/${this.entity}/${this.bundle}?include=${includes}${fields}${languageFilter}${sort}${pageLimit}&filter[status][value]=1${alias}`;
  }

  static get Builder() {
    class Builder {
      constructor(entity, bundle, sort = [], pageLimit, language = '', alias) {
        this.entity = entity;
        this.bundle = bundle;
        this.language = language;
        this.sort = sort;
        this.pageLimit = pageLimit;
        this.alias = alias;
      }

      sortBy(sort) {
        this.sort = sort;
        return this;
      }

      paginate(pageLimit) {
        this.pageLimit = pageLimit;
        return this;
      }

      withIncludes(includes) {
        this.includes = includes;
        return this;
      }

      withFields(fields) {
        this.fields = fields;
        return this;
      }

      filterByLanguage(language) {
        this.language = language;
        return this;
      }

      aliased(alias) {
        if (alias !== 'undefined' && alias === true) {
          this.alias = alias;
        }
        return this;
      }

      build() {
        return new JsonApiEndpoint(this);
      }
    }
    return Builder;
  }
}

module.exports = JsonApiEndpoint;
